<template>
  <social-sharing
    :url="url"
    :title="title"
    :description="content"
    :quote="quote"
    inline-template
  >
    <div>
      {{ $t("Поделиться в") }}
      <network network="facebook">
        <a><i class="pro-icon-facebook1"></i></a>
      </network>
      <network network="twitter">
        <a><i class="pro-icon-twitter1"></i></a>
      </network>
      <network network="vk">
        <a><i class="pro-icon-vk"></i></a>
      </network>
    </div>
  </social-sharing>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    quote: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: window.location.href
    }
  }
}
</script>

<style scoped></style>
